import React from 'react';
import { withTranslation } from 'react-i18next';
import { Field } from 'redux-form'
import { FormGroup, NavLink, Button, ModalHeader, ModalBody } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { numberOnly } from 'lib/fp-utility';

class CCOneTimePassword extends React.Component {
    state = {otp: null}
    submitOTPPassword = this.submitOTPPassword.bind(this)

    componentDidMount(){
        // this.props.change("otp", null)
    }

    submitOTPPassword(e){
        e.preventDefault();
        if (this.state.otp && this.state.otp.length > 3 && typeof this.props.submitOTP === 'function') {
            this.props.submitOTP(this.state.otp);
        }
    }

    validOTP(val){
        return !(val && val.length > 3)
    }

    render() {
        const { t } = this.props
        return (
            <>
                <ModalHeader toggle={this.props.closeSelfOTP}>{t('otp_popup_title')} (OTP)</ModalHeader>
                <ModalBody>
                    <div className="text-center mb-3">
                        <p className="text-16">{t('otp_popup_content_paylater')}</p>
                        <p className="text-16">OTP: {t('otp_popup_content2')}</p>
                        <FormGroup>
                            <form name='OTPACSFORM'>
                                <input className="text-center" maxLength={6} name="otp" 
                                 onChange={(e)=> this.setState({otp: e.target.value})} 
                                 component='input' placeholder="OTP" />
                            </form>
                        </FormGroup>                       
                    </div>
                    {!this.props.loading &&
                    <div className="d-flex" role="group">
                        {this.props.enableResend && 
                        <Button outline color="secondary" disabled={this.props.disableOTPBtn} onClick={this.props.resendOTP}>{t('Resend')} OTP</Button> 
                        }
                        <Button disabled={this.validOTP(this.state.otp)} onClick={this.submitOTPPassword}>{t('Continue')}</Button>
                    </div> 
                    }
                    {this.props.loading &&
                    <p>Validating ...</p> 
                    }
                     
                </ModalBody>
                {/* <h6 className="line-seperater"><span>(OR)</span></h6>
                <div className="footer-link text-center">
                    <NavLink href='#' onClick={this.props.redirectToACS}>{t('card_otp_banklink')}</NavLink>
                    <p>{t('card_otp_note')}</p>
                </div> */}
            </>
        )
    }
}

export default withTranslation('translations')(modalWrapper(true, "CardOTPModal")(CCOneTimePassword));